<template>
  <wo-card v-if="value" :title="$t('general.info')">
    <slot name="actions" slot="actions" />
    <wo-properties mod-bordered>
      <template v-if="value.account_number">
        <wo-properties-label><wo-label v-t="'company.customer'"/></wo-properties-label>
        <wo-properties-value>{{ value.account_number }}</wo-properties-value>
      </template>
      <wo-properties-label><wo-label v-t="'general.createdOn'" /></wo-properties-label>
      <wo-properties-value>{{ value.created_on | date }}</wo-properties-value>
      <wo-properties-label><wo-label v-t="'company.brand'" /></wo-properties-label>
      <wo-properties-value><po-display :value="value.brand" /></wo-properties-value>
      <template v-if="value.owner">
        <wo-properties-label><wo-label v-t="'company.owner'" /></wo-properties-label>
        <wo-properties-value><po-route-link :value="ownerRoute(value)" :label="value.owner.display_name" /> </wo-properties-value>
      </template>
    </wo-properties>
  </wo-card>
</template>

<script>

import { Company } from '@/model/company'

import { ADMIN_USER } from '@/routes/admin'

export default {
  props: {
    value: Company
  },
  methods: {
    ownerRoute (company) {
      return {
        name: ADMIN_USER,
        params: { userId: company.owner.id }
      }
    }
  }
}
</script>
